<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})

</script>
<template>
  <NuxtLayout name="default">
    <v-container>
      <v-row>
        <v-col>
          <h1>
            Unfortunately an error occurred
          </h1>
          <h2>
            {{ error?.statusMessage }}
          </h2>
          <p>
            Please try again later. If the problem persists, please do not hesitate to <nuxt-link to="/contact">contact us</nuxt-link>.
          </p>
          <div style="display:none">
            {{ error }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </NuxtLayout>
</template>
